import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import AlertsList from '../AlertsList';

import './GroupItem.theme.scss';

export default function GroupItem (props) {
  const { alertsIds } = props;

  return (
    <div className="alerts-cluster">
      <AlertsList alertsIds={alertsIds} />
      {alertsIds.size > 1 &&
        <div className="alerts-cluster-disclaimer">Any adjustments (Edit <svg className="svg-icon">
          <use xlinkHref="#icon-pencil"/>
        </svg>) will be applied across the whole group.</div>
      }
    </div>
  );
}

GroupItem.propTypes = {
  alertsIds: PropTypes.instanceOf(List).isRequired,
};
